import {Button, Col, Row} from "reactstrap";
import Link from "next/link";
import React from "react";
import {SearchSelection} from "../../../types/search";
import {FilterSelection} from "../../../types/filterSelection";
import moment from "moment";
import AddToCartButtonMobile from "../../Button/AddToCartButtonMobile";

interface BookingButtonsProps {
    searchSelection: FilterSelection,
    encodedBookingDetails: string,
    price: { price: number, nights: number },
    cottageId: number,
    availabilityOnRequest?: boolean,
    slug?: string
}

const AddToCartButton = React.forwardRef((props: any, ref) => (
    <AddToCartButtonMobile {...props} />
));

const BookingButtons = ({searchSelection, encodedBookingDetails, price, cottageId, slug, availabilityOnRequest = false}: BookingButtonsProps) => {
    const {startDate, endDate} = searchSelection;

    return (
        <>
            <Row className="mb-2">
                <Col>
                    <strong className="text-sm">
                        {moment(startDate).format('DD MMM')} - {moment(endDate).format('DD MMM Y')} voor
                    </strong>
                    <strong>
                        {" "}
                        € {price.price},-
                    </strong>
                </Col>
            </Row>
            <Row>
                <Col>
                    {availabilityOnRequest ?
                        <>
                            <span className="font-weight-bold red">Beschikbaarheid is op aanvraag</span>
                            <Link
                                href={`/aanvraag/beschikbaarheid/[slug]`}
                                as={`/aanvraag/beschikbaarheid/${slug}?aankomst-datum=${startDate}&eind-datum=${endDate}`}
                                passHref
                            >
                                <Button
                                    aria-label="Beschikbaarheid opvragen"
                                    className="book-button mt-2"
                                    color="primary"
                                    block
                                >
                                    Beschikbaarheid opvragen
                                </Button>
                            </Link>
                        </>
                        :
                    <Link
                        href={`/boeken/[details]`}
                        as={`/boeken/${encodedBookingDetails}`}
                        passHref
                    >
                        <AddToCartButton
                            cottageId={cottageId}
                            startDate={startDate}
                            endDate={endDate}
                        />
                    </Link>
                    }
                </Col>
            </Row>
        </>
    );
}

export default BookingButtons;
